import React from 'react';

import { motion } from 'framer-motion';

import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';



import './header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => {
  return (
    <>
      {/* === Start my Info ===*/}
      <motion.div
        className='app_header-info'
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 1 }}>
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className='p-text'>Hello, I am</p>
              <h1 className='head-text'> Oubaida</h1>
            </div>
          </div>

          <div className='tag-cmp app__flex'>
            <p className='p-text'>Software Engineer</p>
            <p className='p-text'>Web Developer</p>
          </div>
        </div>
      </motion.div>

      {/* === End my Info ===*/}

      {/* === Start my pic ===*/}

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'>
        <img src={images.profile} alt='profile_bg' />

        {/* === Grey image behind my pic === */}
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle'
        />
      </motion.div>

      {/* === End my pic ===*/}

      {/* === Start flutter and redux images ===*/}

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'>
        {[images.react, images.redux, images.sass].map(
          (circle, index) => (
            <div className='circle-cmp app__flex' key={`circle-${index}`}>
              <img src={circle} alt='profile_bg' />
            </div>
          )
        )}
      </motion.div>

      {/* === End flutter and redux images ===*/}
    </>
  );
};

export default AppWrap(
  MotionWrap(Header, 'app_header'),
  'home',
  'app__primarybg'
);

// AppWrap(Header, 'home');
